<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapGetters,mapActions,mapState } from "vuex"
    // import axios from 'axios';
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Sales Balance Report",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect,        
      },
      data() {
        return {
          total_sum: 0,
          total_sales: 0,
          total_paid: 0,
          filterSales:{
            datefrom: moment(new Date()).format("YYYY-MM-DD"),
            dateto: moment(new Date()).format("YYYY-MM-DD"),
            user: '',
            category: '',
            branch_id:0
          },
          currentdate: moment(new Date()).format("YYYY-MM-DD"),
          title: "Sales Balance Report",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Sales Balance Report",
              active: true,
            },
          ],
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "total_sum",
              sortable: true,
              label: 'TOTAL SUM',
            },
            {
              key: "total",
              sortable: true,
              label: 'SALE TOTAL',
            },
            {
              key: "total_paid",
              sortable: true,
              label: 'TOTAL PAID',
            },
            {
              key: "date",
              sortable: true,
              label: "DATE",
            },
            {
              key: "user",
              sortable: true,
              label: "ADDED BY",
            },
            {
              key: "receipt",
              sortable: true,
              label: "RECEIPT",
            },
            {
              key: "details",
              sortable: true,
              label: "DETAILS",
            },
            {
              key: "status",
              sortable: true,
              label: "STATUS",
            }
          ],
        //   fields1: [
        //     {
        //       key: "index",
        //       sortable: true,
        //       label: "S/N",
        //     },
        //     {
        //       key: "product",
        //       sortable: true,
        //       label: 'PRODUCT',
        //     },
        //     {
        //       key: "qty",
        //       sortable: true,
        //       label: 'QUANTITY',
        //     },
        //     {
        //       key: "SPrice_no",
        //       sortable: true,
        //       label: 'UNIT PRICE',
        //     },
        //     {
        //       key: "total_price",
        //       sortable: true,
        //       label: 'TOTAL PRICE',
        //     },
        //     {
        //       key: "sale.sale_date",
        //       sortable: true,
        //       label: "DATE",
        //     },
        //     {
        //       key: "user.name",
        //       sortable: true,
        //       label: "ADDED BY",
        //     },
        //     {
        //       key: "receipt",
        //       sortable: true,
        //       label: "RECEIPT",
        //     },
        //     {
        //       key: "branch",
        //       sortable: true,
        //       label: "BRANCH",
        //     }
        //   ],
        };
      },
      computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
        ...mapGetters("saledetails", ["filterStatus","SalesBalance"]),
        ...mapGetters("auth", ["business","branch", "Branches","branchid"]),
        ...mapGetters("products", ["Categories"]),
        ...mapGetters("users", ["Users"]),
        ...mapGetters("setting", ["GeneralSettings"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.SalesBalance ? this.SalesBalance.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.SalesBalance ? this.SalesBalance.length : 1;
      },  
      methods: {
        ...mapActions({
          FetchSalesBalance: "saledetails/fetchSalesBalance",
          FetchProducts: "products/fetchProducts",
          FetchUsers: "users/fetchUsers",
          FetchCategories: "products/fetchPCategories",
          FetchGeneralSettings: "setting/fetchGeneralSettings",
          FetchBranches: "auth/fetchBranches",
    
        }),
    
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/[^0-9.]+/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        SalesBalanceData() {
          this.FetchSalesBalance(this.filterSales);
        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },

        rowClass(item) {
            // Define your condition here.
            if (item.totalAmt != item.SumTotal) {
                return 'highlight-row'; // Apply this class if the condition is met
            }
            return ''; // No class if the condition is not met
        },
        Viewdetails(pid){
          this.$router.push(`/sale_details/${btoa(pid)}`);
        }
      },
      updated() {
        let total_sum = 0;
        let total_paid = 0;
        let total_sales = 0;
          // let total_paid = 0;
          if(this.SalesBalance){
            this.SalesBalance.forEach((item)=>{
              total_sales = total_sales+parseInt(item.totalAmt);
              total_sum = total_sum+parseInt(item.SumTotal);
              total_paid = total_paid+parseInt(item.totalPaid);
            });
            this.total_sales = total_sales;            
            this.total_sum = total_sum;            
            this.total_paid = total_paid;            
          }
      },
      watch: {
        SalesBalance(newValue){
          if(newValue == true){
            this.SalesBalanceData();
          }
        }
      },
      created() {
        this.FetchSalesBalance(this.filterSales);
        this.FetchProducts();
        this.SalesBalanceData();
        this.FetchUsers();
        this.FetchCategories();
        this.FetchGeneralSettings();
        this.FetchBranches();
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">                
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center">Sales Balance Report from {{filterSales.datefrom}} to {{filterSales.dateto}}</h3>
                  </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group mb-2">
                    <label>FROM</label>
                    <input
                      type="date"
                      v-model="filterSales.datefrom"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>TO</label>
                    <input
                      v-model="filterSales.dateto"
                      type="date"
                      class="form-control"
                    />
                  </div>                
                  <div class="col-md-3 form-group">
                    <label>USERS</label>
                    
                    <model-list-select
                      :list="Users ? Users : []"
                      v-model="filterSales.user"
                      option-value="id"
                      option-text="names"
                      placeholder="Select User"
                      @input="SalesBalanceData()"
                    >
                    </model-list-select>
                  </div>
                  <div class="col-md-3 mt-4">
                  <button class="btn btn-primary" type="button" @click="SalesBalanceData()">
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
                </div>            
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="SalesBalance?SalesBalance:[]"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :row-class="rowClass"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template> 
                    <template #cell(total)="data">
                      {{ data.item.totalAmt?data.item.totalAmt.toLocaleString():0 }}
                    </template>
                    <template #cell(total_paid)="data">
                      {{ data.item.totalPaid?data.item.totalPaid.toLocaleString():0 }}
                    </template>   
                    <template #cell(total_sum)="data">
                      {{data.item.SumTotal?data.item.SumTotal.toLocaleString():0 }}
                    </template>
                    <template #cell(details)="data">
                      <b-button variant="success" size="sm" @click="Viewdetails(data.item.payment)">Details</b-button>
                    </template> 
                    <template #cell(status)="data">
                      <span><i class="fa fa-times-circle text-danger" v-if="data.item.SumTotal != data.item.totalAmt"></i><i class="fa fa-check-circle text-success" v-else></i></span>
                    </template>           
                  </b-table>
                  <div class="row">
                      <div class="col-md-4">
                        <h5>Total Amount: <span class="text-danger">{{total_sales?thousandSeperator(total_sales):0}}</span></h5>
                      </div>
                      <div class="col-md-4">
                        <h5>Total Sales: <span class="text-danger">{{total_sum?thousandSeperator(total_sum):0}}</span></h5>
                      </div>
                      <div class="col-md-4">
                        <h5>Total Paid: <span class="text-danger">{{total_paid?thousandSeperator(total_paid):0}}</span></h5>
                      </div>
                    </div>
                </div>
                <Loader  v-if="!SalesBalance"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    /* Define the highlight-row class to style the row */
    .highlight-row {
        background-color: #ffdddd; /* Light red background */
    }
    </style>
    